import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import {
  REJECTION_REASONS,
  REJECTION_REASONS_COMMERCIAL,
  REJECTION_REASONS_COMMERCIAL_LIST,
  REJECTION_REASONS_LIST,
} from "../../../utils/constants";
import "../CSS/RejectTripDialog.css";

const RejectTripDialog = ({
  open,
  onClose,
  onReject,
  tripData,
  isLoading = false,
  isCommercial = false,
}) => {
  const [selectedReason, setSelectedReason] = useState("");

  useEffect(() => {
    if (open) {
      setSelectedReason("");
    }
  }, [open]);

  const getRejectionReasonKey = (reasonText) => {
    if (isCommercial) {
      for (const [key, value] of Object.entries(REJECTION_REASONS_COMMERCIAL)) {
        if (value === reasonText) {
          return key;
        }
      }
      return null;
    } else {
      for (const [key, value] of Object.entries(REJECTION_REASONS)) {
        if (value === reasonText) {
          return key;
        }
      }
    }
    return null;
  };

  const handleReject = () => {
    if (selectedReason) {
      const reasonKey = getRejectionReasonKey(selectedReason);
      onReject(tripData, reasonKey);
    }
  };

  const handleClose = () => {
    onClose();
    setSelectedReason("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        className: "reject-trip-dialog-container",
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="reject-trip-dialog-close"
          onClick={handleClose}
        />
        <div className="reject-trip-dialog-content">
          <div className="reject-trip-dialog-title">
            {" "}
            {isCommercial ? "Reject Commercial Flight Plan" : "Reject Trip"}
          </div>

          <div className="reject-trip-dialog-subtitle">
            Select Rejection Reason
          </div>

          <div className="rejection-reasons">
            {isCommercial
              ? REJECTION_REASONS_COMMERCIAL_LIST.map((reason, index) => (
                  <label key={index} className="reason-option">
                    <input
                      type="radio"
                      name="rejectionReason"
                      value={reason}
                      checked={selectedReason === reason}
                      onChange={(e) => setSelectedReason(e.target.value)}
                    />
                    <span className="reason-text">{reason}</span>
                  </label>
                ))
              : REJECTION_REASONS_LIST.map((reason, index) => (
                  <label key={index} className="reason-option">
                    <input
                      type="radio"
                      name="rejectionReason"
                      value={reason}
                      checked={selectedReason === reason}
                      onChange={(e) => setSelectedReason(e.target.value)}
                    />
                    <span className="reason-text">{reason}</span>
                  </label>
                ))}
          </div>

          <Button
            variant="contained"
            onClick={!isLoading ? handleReject : null}
            disabled={!selectedReason || isLoading}
            className="reject-button-dialog"
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Reject
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RejectTripDialog;
